import { render, staticRenderFns } from "./cModalUpdateSale.vue?vue&type=template&id=20c49750&scoped=true"
import script from "./cModalUpdateSale.vue?vue&type=script&lang=js"
export * from "./cModalUpdateSale.vue?vue&type=script&lang=js"
import style0 from "./cModalUpdateSale.vue?vue&type=style&index=0&id=20c49750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c49750",
  null
  
)

export default component.exports